<template>
	<v-container class="fill-height">
		<v-row justify="space-around">
			<v-col cols="4" class="text-center">
				<h1>Successfully connected {{ serviceSlug }}.</h1>
				<h2>Go ahead and start by creating a new element on {{ serviceSlug }} using the Ply Chrome extenstion.</h2>
				<br />
				<h3>Or</h3>
				<h3><router-link :to="{ name: 'NewFeature', query: { w: 1 } }">Create a new workflow</router-link></h3>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
/* eslint-disable no-undef */
export default {
	name: 'IntegrationConnected',
	props: {
		serviceSlug: {
			type: String,
			required: true,
		},
	},
	computed: {},
	methods: {},
	async mounted() {},
};
</script>

<style scoped></style>
